let product_card_list = document.querySelectorAll('product-card');
let product_card_array = [...product_card_list];
let add_to_cart_icon_content ='<span class="visually-hidden">Add to cart</span><svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M12.12 20.44H5.6V9.56h12.8v3.73c.06.4.4.69.8.7.44 0 .8-.35.8-.8v-4.5a.792.792 0 0 0-.8-.69H17V6.5C16.9 4 14.7 2 12 2S7 4.09 7 6.67V8H4.71c-.4.04-.71.37-.71.78v12.53a.8.8 0 0 0 .8.69h7.43c.38-.06.67-.39.67-.78 0-.43-.35-.78-.78-.78ZM8.66 6.67c0-1.72 1.49-3.11 3.33-3.11s3.33 1.39 3.33 3.11V8H8.65V6.67Z"></path><path d="M20 17.25h-2.4v-2.5a.817.817 0 0 0-.8-.7c-.44 0-.8.36-.8.8v2.4h-2.5c-.4.06-.7.4-.7.8 0 .44.36.8.8.8H16v2.5c.06.4.4.7.8.7.44 0 .8-.36.8-.8v-2.4h2.5c.4-.06.69-.4.7-.8 0-.44-.35-.8-.8-.8Z"></path></svg>';
product_card_array.forEach(product_card => {
    const config = { attributes: true };
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes") {
                if(product_card.querySelector('button[name="add"]').classList.contains("gPreorderHidden") && product_card.getElementsByClassName('product-inventory__status').length !== 0)
                {
                    let inventoryStatus = product_card.getElementsByClassName('product-inventory__status')[0];
                    let etaDate = product_card.querySelector('.product-eta-metafield');
                    if(etaDate && etaDate.textContent.trim())
                    {
                        inventoryStatus.textContent = 'Pre-Order Today - Be the first to get it in '+ etaDate.textContent.trim();
                    }else
                    {
                        inventoryStatus.textContent = 'Pre-Order Today';
                    }
                    inventoryStatus.setAttribute("data-inventory-level", "very_low");
                    let addToCartIcon = product_card.getElementsByClassName('gPreorderBtnLoaded');
                    addToCartIcon[0].innerHTML = '' ;
                    addToCartIcon[0].innerHTML = add_to_cart_icon_content ;
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(product_card.querySelector('button[name="add"]'), config);

    // customize Hide 'Add cart' icon for Out of stock
    if (product_card.querySelector('span[hide_inventory="true"]')) {
        product_card.querySelector('button[name="add"]').classList.add("btn-hidden-mobile");
    }
  
});
